export default "assets/images/icons/agression-b44edbe5.svg";